import axios from "axios";

// import { Message } from "element-ui";
// import router from "@/router";

const request = axios.create({
    baseURL: process.env.VUE_APP_URL
})

// 添加响应拦截器
request.interceptors.response.use( response => {
    // 对响应数据做点什么
    let { data } = response
    return data;
}, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default request;